import api from './api';

/**
 * SCAC Profiles — option bundle + chassis-override subtable for the bespoke edit drawer
 * (cms.scacprofiles). The parent record uses the generic /tablemaint engine; this service
 * serves the Provider/Pool/Region option lists and the per-parent chassis overrides
 * (cms.scacprofiles_chassisoverride, keyed by the parent recno).
 */
export interface ScacFormOptions {
  providers: string[];
  pools: string[];
  regions: string[];
}

export interface ChassisOverride {
  recno: number;
  region: string;
  preferredchassisprovider: string;
  chassispool: string;
}

export async function getScacFormOptions(): Promise<ScacFormOptions> {
  const res = await api.get('/scacprofiles/form-options');
  return res.data as ScacFormOptions;
}

export async function getChassisOverrides(parentRecno: number): Promise<ChassisOverride[]> {
  const res = await api.get(`/scacprofiles/${parentRecno}/overrides`);
  return res.data as ChassisOverride[];
}

export async function createChassisOverride(
  parentRecno: number,
  body: { region: string; preferredchassisprovider: string; chassispool: string },
): Promise<{ recno: number }> {
  const res = await api.post(`/scacprofiles/${parentRecno}/overrides`, body);
  return res.data as { recno: number };
}

export async function updateChassisOverride(
  overrideRecno: number,
  body: Partial<{ region: string; preferredchassisprovider: string; chassispool: string; deleted: string }>,
): Promise<{ recno: number }> {
  const res = await api.put(`/scacprofiles/overrides/${overrideRecno}`, body);
  return res.data as { recno: number };
}

/** Readonly Per Diem Information (contact/phone/fax/email/comments) from the active
 *  steamship-line scacprofiles row for a SCAC — shown at the foot of the SSL Per Diem
 *  drawer. Blank when the SCAC has no active profile. */
export interface ScacPerDiemInfo {
  perdiemcontact: string;
  perdiemphone: string;
  perdiemfax: string;
  perdiememail: string;
  comments: string;
}

export async function getScacPerDiemInfo(scac: string): Promise<ScacPerDiemInfo> {
  const res = await api.get('/scacprofiles/perdiem-info', { params: { scac } });
  return res.data as ScacPerDiemInfo;
}
